var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingWheelSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillRule: "evenodd",
    d: "M4.833 11.227c.245.082.491.123.737.164.246.04.491.04.737.04 1.557 0 2.99-.614 4.014-1.637A5.7 5.7 0 0 0 12 5.78c0-1.597-.655-2.99-1.68-4.013A5.7 5.7 0 0 0 6.308.087a5.7 5.7 0 0 0-4.013 1.68C1.311 2.75.697 4.06.615 5.576H0l1.27 1.966L2.5 5.576h-.655c.082-1.147.532-2.212 1.31-2.95a4.426 4.426 0 0 1 3.154-1.31c1.228 0 2.334.492 3.154 1.31.819.78 1.31 1.926 1.31 3.155a4.426 4.426 0 0 1-1.31 3.153 4.566 4.566 0 0 1-3.154 1.27h-.573c-.205-.04-.369-.082-.574-.123l-.327 1.147h-.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingWheelSmall);
export default __webpack_public_path__ + "static/media/loading-wheel-small.ae710cf70c7be61610ece66c7c69bbe2.svg";
export { ForwardRef as ReactComponent };